import { render } from "./FeedbackForm.vue?vue&type=template&id=49481bd6&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"

import "./FeedbackForm.vue?vue&type=style&index=0&id=49481bd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49481bd6"]])

export default __exports__